import { useState } from 'react';

import LoginForm from './LoginForm';
import RegisterForm from './/RegisterForm';
import Verification from './Verification';
import AccountEmail from './AccountEmail';
import CodeVerificationStepOne from './CodeVerificationStepOne';
import CodeVerificationStepTwo from './CodeVerificationStepTwo';
import { ReactComponent as LogoImg } from '../../../img/logo.svg';

import './loyoutAuth.scss';


const LoyoutAuth = () => {
    const [page, setPage] = useState(0)
    const [code, setCode] = useState(null)

    const handlePage = (num) => {
        setPage(num)
    }

    const handleCodeVerification = (code) => {
        setCode(code)
    }

    const pageDisplay = () => {
        switch (page) {
            case 0:
                return (<LoginForm handlePage={handlePage} />)
            case 1:
                return (<RegisterForm handlePage={handlePage} />)
            case 2:
                return (<Verification handlePage={handlePage} />)
            case 3:
                return (<AccountEmail handlePage={handlePage} />)
            case 4:
                return (<CodeVerificationStepOne handlePage={handlePage} handleCodeVerification={handleCodeVerification} />)
            case 5:
                return (<CodeVerificationStepTwo handlePage={handlePage} code={code} />)
            default:
                break;
        }
    }

    return (
        <section >
            <div className='loyoutAuth-section'>
                <div className='login_section'>
                    <div className='login_section-logo'>
                        <LogoImg className='logo_section-img' />
                        <h3 className='logo_title'>Reticle Editor</h3>
                    </div>

                    <div className='login_text-section'>
                        <p className='login_textH1'>
                            ATN RETICLE EDITOR
                        </p>
                        <p className='login_textH2'>
                            Please authorize to Reticle Editor to design your next perfect shot.
                        </p>
                    </div>
                </div>
                {/* <img src={loginLeftImg} alt='login image' /> */}
                {pageDisplay()}
            </div>
        </section>

    )
}

export default LoyoutAuth;
